import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Row, Col, message } from 'antd';
import { InboundOrOutboundOrderDetails } from 'components/inbound-outbound-orders/details';
import PdButton from 'components/pd-button';
import { SecretCodeModal } from './secretCodeModal';
import OrderPickUpService from 'services/order-pickup';
import OrderService from 'services/order';
import OrderActivity from 'services/order';
import queryString from 'query-string';
import { errHandling } from 'utils';
import { get } from 'lodash';

export function OutboundOrderDetails() {
  const [showInputSecretCodeModal, setShowInputSecretCodeModal] =
    useState(false);
  const [orderDetail, setOrderDetail] = useState({});
  const [orderActivity, setOrderActivity] = useState([]);
  const location = useLocation();

  const { id } = queryString.parse(location.search) || {};
  const navigate = useNavigate();

  async function getOrderActivity() {
    try {
      const {
        data: { data },
      } = await OrderActivity.getOrderActivity(id);
      setOrderActivity(data);
    } catch (error) {
      errHandling(error);
    }
  }

  async function getOrderPickUpDetail() {
    try {
      const {
        data: { data },
      } = await OrderPickUpService.getOrderDetails(id);
      setOrderDetail(data);
    } catch (error) {
      errHandling(error);
    }
  }

  async function handleOnSubmitSecretCode(payload) {
    try {
      await OrderPickUpService.completeOrder(id, payload);
      setShowInputSecretCodeModal(false);
      message.success('Order completed');
      navigate('/pickup_points/outbound-order', { replace: true });
    } catch (error) {
      errHandling(error);
    }
  }

  async function resendPickupCode() {
    if (id) {
      try {
        await OrderPickUpService.resendPickupCode(id);
        message.success('Your pickup code has been sent');
      } catch (error) {
        errHandling(error);
      }
    }
  }

  async function handoverPickup() {
    try {
      await OrderService.handoverPickup(id);
      getOrderPickUpDetail();
      getOrderActivity();
      message.success('successfully handover to customer');
    } catch (error) {
      errHandling(error);
    }
  }

  useEffect(() => {
    if (id) {
      getOrderPickUpDetail();
      getOrderActivity();
    }
    // eslint-disable-next-line
  }, [id]);

  return (
    <InboundOrOutboundOrderDetails
      orderDetail={orderDetail}
      orderActivity={orderActivity}>
      <Row gutter={[0, 8]}>
        <Col span={24}>
          <PdButton
            full
            type="primary"
            onClick={() => setShowInputSecretCodeModal(true)}>
            Input Secret Code
          </PdButton>
        </Col>
        <Col span={24}>
          <PdButton full type="primary" onClick={resendPickupCode}>
            Resend Pickup Code
          </PdButton>
        </Col>
        {get(orderDetail, 'status', '') === 'arrived_at_pickup' && (
          <Col span={24}>
            <PdButton full type="primary" onClick={handoverPickup}>
              Handover To Customer
            </PdButton>
          </Col>
        )}
      </Row>
      <SecretCodeModal
        onCancel={() => setShowInputSecretCodeModal(false)}
        onSubmit={handleOnSubmitSecretCode}
        orderDetail={orderDetail}
        open={showInputSecretCodeModal}
      />
    </InboundOrOutboundOrderDetails>
  );
}
